// Labels and colors for GAEB position kinds (tag codes from calc.js#tagsOf).

export const TAG_COLORS = {
  base: "blue",
  alternative: "purple",
  markup: "cyan",
  provisional_with_total: "gold",
  provisional_without_total: "gold",
  lump_sum: "geekblue",
  hourly: "geekblue",
  surcharge: "default",
  free_quantity: "orange",
  not_applicable: "default",
  awarded: "success"
};

export const tagLabels = t => ({
  base: t("Base position"),
  alternative: t("Alternative position"),
  markup: t("Markup position"),
  provisional_with_total: t("Contingency position (with total)"),
  provisional_without_total: t("Contingency position (unit price only)"),
  lump_sum: t("Lump sum"),
  hourly: t("Daywork"),
  surcharge: t("Surcharge"),
  free_quantity: t("Quantity by bidder"),
  not_applicable: t("Not applicable"),
  awarded: t("Ordered")
});
